import { Message } from 'element-ui';
import axios from 'axios';
import store from '@/store';
import { getItem, removeItem } from '../utils/cookie.js';
let status = false
const request = baseURL => {
  const $http = axios.create({
    baseURL
  });
  $http.interceptors.request.use(async config => {
    const WEB_URL = location.origin;
    const API_URL = baseURL;
    const TEST_ADDRESS = [
      'https://testgw.syounggroup.com',
      'http://localhost:8080',
    ];
    const PRO_ADDRESS = [
      'https://gw.syounggroup.com',
    ];
    if (PRO_ADDRESS.includes(WEB_URL)) {
      if (!API_URL.includes('https://gw.syounggroup.com/')) {
        Message.error('请求拒绝，正式环境前端应用调用了非正式环境接口地址。');
        return false;
      }
    }
    if (TEST_ADDRESS.includes(WEB_URL)) {
      if (!API_URL.includes('https://testgw.syounggroup.com/')) {
        Message.error('请求拒绝，测试环境前端应用调用了非测试环境接口地址。');
        return false;
      }
    }
    if (getItem('sessionId')) {
      config.headers['X-Session-Id'] = getItem('sessionId');
    } else if (localStorage.getItem('sessionId')) {
      config.headers['X-Session-Id'] = localStorage.getItem('sessionId');
    }
    config.headers['X-Tenant-Id'] = 'cml-main-service';
    config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    // cancelToken取消请求
    config.cancelToken = new axios.CancelToken(cancel => {
      store.commit('cancelRequest/pushToken', { cancelToken: cancel });
    })
    return config;
  });

  $http.interceptors.response.use(
    res => {
      if (res.data instanceof ArrayBuffer) {
        // 如果是文件流
        return res.data;
      }
      if (!res) {
        return Promise.reject({
          ...res.data,
          msg: 'code 200 ,response is null ！'
        });
      }
      if (res.data.code === '0') {
        if (!res.data.data) {
          return {
            ...res.data,
            data: {}
          };
        }
        return res.data;
      } else {
        if (res.data.code === '400') {
          removeItem();
          // 防止多次错误弹窗
          if (!status) {
            status = true;
            store.dispatch('user/clearLoaclstorage');
            // 未关闭浏览器，session失效
            if (sessionStorage.getItem('sessionValid') === '1') {
              Message.error('登录信息过期，请重新登录。');
              setTimeout(() => {
                location.reload();
              }, 2000)
            } else {
              // 关闭浏览器后，session失效
              location.reload();
            }
            return Promise.reject({});
          }
        } else
          if (!res.data.msg) {
          return Promise.reject({
            ...res.data,
            msg: '程序发生了错误！'
          });
        } else {
          return Promise.reject(res.data);
        }
      }
    },
    ({ response }) => {
      if (response.status >= 500) {
        return Promise.reject({
          ...response.data,
          msg: response.data.message || '异常'
        });
      }
      return Promise.reject(
        new Error({
          code: response.status,
          msg: response.statusText
        })
      );
    }
  );
  return $http;
};

export default request;
